import style from "./account.module.scss";
import AccountProfile from "./AccountProfile";
import Card from "./Card";
import AccountMenu from "./AccountMenu";
import Logout from "./Logout";
import useAuth, {TYPE_USER} from "../../hooks/useAuth";
import toTitleCase from "../../utils/toTitleCase";


const determineProfileName = authDetails => {
    if(authDetails?.type === TYPE_USER) {
        if(authDetails.institutionName) {
            return toTitleCase(authDetails.institutionName);
        } else {
            return `${authDetails.givenName} ${authDetails.familyName || ''}`.trim()
        }
    } else if(authDetails?.type === 'institution') {
        return authDetails.institutionName;
    }
    return undefined;
};

const determineEmail = authDetails => authDetails?.email;

const AccountForLoggedInUser = () => {
    const { authDetails } = useAuth();

    const profileName = determineProfileName(authDetails);
    const email = determineEmail(authDetails);

    return (
        <div className={style.loginItems}>
            <AccountProfile
                name={profileName}
                email={email}
            />
            <div className={style.cardRow}>
                <Card name="My Favourites" route="/app/fav" iconname="Favourite" />
                <Card
                    name="Saved Search"
                    route="/app/savedSearch"
                    iconname="Saved"
                />
            </div>
            {/* todo:navigation  */}
            <div className={style.menuList}>
                <AccountMenu
                    name="Change Password"
                    route="/app/updatepassoword"
                    isListTop
                />
                <AccountMenu name="Subscriptions" route="/app/updatepassoword" />
                <AccountMenu name="What’s New" route="/app/updatepassoword" />
                <AccountMenu name="About Us & Legal" route="/app/updatepassoword" />
            </div>
            <div className={style.cardRow}>
                <p>
                    We welcome feedback from our community; please contact <a className={style.underline} href="mailto:feedback@tg.org.au">feedback@tg.org.au</a>.
                </p>
            </div>
            <Logout />
        </div>
    )
};

export default AccountForLoggedInUser;
